import React from 'react';

import { NotificationList } from 'constants/notifications';
import { useTranslationsContext } from 'contexts/translationsContext';
import { NotificationProps } from 'models/props';
import { useIsLessThan } from 'fxs-utils';

import { IconCheck, IconX } from '@tabler/icons-react';

import { Bell } from './bell';
import {
	CloseIcon,
	NotificatiionSnackbarP,
	NotificationCloseText,
	NotificationDescription,
	NotificationGreybox,
	NotificationIcon,
	NotificationModalAllOnP,
	NotificationModalAllOnWrapper,
	NotificationModalDescription,
	NotificationModalIcon,
	NotificationModalIconWrapper,
	NotificationModalSwitchCircle,
	NotificationModalSwitchWrapper,
	NotificationsBackdrop,
	NotificationsModalBody,
	NotificationsModalBtnReset,
	NotificationsModalBtnSave,
	NotificationsModalBtnWrapper,
	NotificationsModalCheckbox,
	NotificationsModalRow,
	NotificationsModalSuggestions,
	NotificationsModalSuggestionsP,
	NotificationsModalTypeformPopUpBtn,
	NotificationsSidebar,
	NotificationsSidebarHeader,
	NotificationsSidebarTitle,
	NotificationsSnackbar
} from './styles';
import { useNotification } from './useNotifications';

const NotificationsModal: React.FC<NotificationProps> = ({
	elementRef,
	isNotificationsModalOpened,
	setIsNotificationsModalOpened
}) => {
	const {
		handleCloseModal,
		handleAllNotificationsOn,
		handleNotifications,
		save,
		resetNotifications,
		allNotificationsOn,
		changesSaved,
		state,
		areChanges
	} = useNotification(
		isNotificationsModalOpened,
		setIsNotificationsModalOpened
	);
	const { t } = useTranslationsContext();

	const isLessThan833 = useIsLessThan(833);
	const dismissedNotificationDescription = localStorage.getItem(
		'dismissedNotificationDescription'
	);

	return (
		<NotificationsBackdrop
			isNotificationsModalOpened={isNotificationsModalOpened}
		>
			<NotificationsSidebar ref={elementRef}>
				<NotificationsSidebarHeader>
					<NotificationsSidebarTitle>
						{t('notificationPreferences')}
					</NotificationsSidebarTitle>
					<CloseIcon
						as={IconX}
						stroke={2}
						onClick={handleCloseModal}
					/>
				</NotificationsSidebarHeader>
				{!dismissedNotificationDescription && (
					<NotificationGreybox show={true}>
						<div>
							<NotificationDescription>
								{t('notificationDescription')}
							</NotificationDescription>
							<NotificationCloseText
								onClick={(e) => {
									handleCloseModal(e);
									localStorage.setItem(
										'dismissedNotificationDescription',
										'true'
									);
								}}
							>
								{t('notificationCloseText')}
							</NotificationCloseText>
						</div>
						<Bell />
					</NotificationGreybox>
				)}
				<NotificationsModalBody>
					<NotificationModalAllOnWrapper>
						<NotificationModalAllOnP>
							{t('allCategoryOn')}
						</NotificationModalAllOnP>
						<NotificationsModalCheckbox>
							<NotificationModalSwitchWrapper
								isActive={allNotificationsOn}
								onClick={handleAllNotificationsOn}
							>
								<NotificationModalSwitchCircle
									isActive={allNotificationsOn}
									onClick={handleAllNotificationsOn}
								/>
							</NotificationModalSwitchWrapper>
						</NotificationsModalCheckbox>
					</NotificationModalAllOnWrapper>
					{NotificationList.map((notification) => (
						<NotificationsModalRow
							key={notification.id}
							onClick={() => handleNotifications(notification.id)}
						>
							<NotificationModalIconWrapper>
								<NotificationModalIcon />
							</NotificationModalIconWrapper>
							<NotificationModalDescription>
								<h3>{t(notification.title)}</h3>
								<p>{t(notification.description)}</p>
							</NotificationModalDescription>
							<NotificationsModalCheckbox>
								<NotificationModalSwitchWrapper
									isActive={state[notification.id]}
									onClick={() =>
										handleNotifications(notification.id)
									}
								>
									<NotificationModalSwitchCircle
										isActive={state[notification.id]}
										onClick={() =>
											handleNotifications(notification.id)
										}
									/>
								</NotificationModalSwitchWrapper>
							</NotificationsModalCheckbox>
						</NotificationsModalRow>
					))}
				</NotificationsModalBody>

				<NotificationsModalSuggestions>
					<NotificationsModalSuggestionsP>
						{t('notificationSuggestions')} {isLessThan833 && <br />}
						<strong>{t('letUsKnow')}</strong>
					</NotificationsModalSuggestionsP>
					<NotificationsModalTypeformPopUpBtn id='Bb59aAVk'>
						{t('sendSuggestions')}
					</NotificationsModalTypeformPopUpBtn>
				</NotificationsModalSuggestions>

				<NotificationsModalBtnWrapper>
					{changesSaved && (
						<NotificationsSnackbar>
							<NotificationIcon as={IconCheck} stroke={2} />
							<NotificatiionSnackbarP>
								{t('changesSaved')}
							</NotificatiionSnackbarP>
						</NotificationsSnackbar>
					)}

					<NotificationsModalBtnSave
						onClick={save}
						disabled={!areChanges}
					>
						{t('save')} {isLessThan833 ? '' : t('preferences')}
					</NotificationsModalBtnSave>
					<NotificationsModalBtnReset
						onClick={resetNotifications}
						disabled={!areChanges}
					>
						{t('reset')} {isLessThan833 ? '' : t('preferences')}
					</NotificationsModalBtnReset>
				</NotificationsModalBtnWrapper>
			</NotificationsSidebar>
		</NotificationsBackdrop>
	);
};

export default NotificationsModal;
